import { Link } from "react-router-dom";
import { ShoppingCart, Store } from "lucide-react";
import { useCart } from "../context/CartContext";
import { fmt } from "../lib/api";
import { DemoBadge, Stars } from "./ui";

export default function ProductCard({ p }) {
  const { add } = useCart();
  const best = p.best_offer;
  const out = !best || best.stock <= 0;
  return (
    <div className="bo-card group flex flex-col overflow-hidden transition-transform duration-300 hover:-translate-y-1" data-testid={`product-card-${p.id}`}>
      <Link to={`/produto/${p.id}`} className="relative block aspect-[4/3] overflow-hidden bg-gray-50" data-testid={`product-link-${p.id}`}>
        <img src={p.image} alt={p.name} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
        {p.discount > 0 && <span className="absolute left-2 top-2 rounded-full bg-red-600 px-2 py-0.5 text-xs font-bold text-white" data-testid="discount-badge">-{p.discount}%</span>}
        {p.is_demo && <DemoBadge className="absolute right-2 top-2" />}
      </Link>
      <div className="flex flex-1 flex-col gap-1.5 p-3">
        <Link to={`/produto/${p.id}`} className="line-clamp-2 min-h-[40px] text-sm font-semibold leading-5 hover:text-bo-green">{p.name}</Link>
        <p className="flex items-center gap-1 truncate text-xs text-gray-500" data-testid="product-supplier">
          <Store className="h-3 w-3 shrink-0" />{best?.store?.name}
          {p.offers_count > 1 && <span className="ml-1 rounded bg-bo-green/10 px-1.5 font-semibold text-bo-green">+{p.offers_count - 1} lojas</span>}
        </p>
        <Stars value={p.rating} count={p.reviews_count} />
        <div className="mt-auto flex items-end justify-between gap-2 pt-1">
          <div>
            <p className="text-lg font-extrabold text-bo-green" data-testid="product-price">{fmt(best?.price)}</p>
            {best?.old_price > best?.price && <p className="text-xs text-gray-400 line-through">{fmt(best.old_price)}</p>}
          </div>
          <button disabled={out} onClick={() => add(p, best)} data-testid={`add-to-cart-${p.id}`} title="Adicionar ao carrinho"
            className="grid h-10 w-10 place-items-center rounded-full bg-bo-yellow text-bo-ink transition-transform hover:scale-110 disabled:opacity-40">
            <ShoppingCart className="h-[18px] w-[18px]" />
          </button>
        </div>
        {out && <p className="text-xs font-medium text-red-600">Sem stock</p>}
      </div>
    </div>
  );
}

export const ProductGrid = ({ items }) => (
  <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 2xl:grid-cols-4" data-testid="product-grid">
    {items.map((p) => <ProductCard key={p.id} p={p} />)}
  </div>
);
